import { render, staticRenderFns } from "./AdresList.vue?vue&type=template&id=0b4aaf0c"
import script from "./AdresList.vue?vue&type=script&lang=ts"
export * from "./AdresList.vue?vue&type=script&lang=ts"
import style0 from "./AdresList.vue?vue&type=style&index=0&id=0b4aaf0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports